/* eslint-disable class-methods-use-this */
import { isEmpty, map } from 'lodash';
import ApplicationController from '../application_controller';

/* global $ */
export default class extends ApplicationController {
  connect() {
    this.tagsEliminados = [];
    this.$select = $(this.element.querySelector('#select-etiquetas'));
    this.$inputEliminados = $(this.element.querySelector('#etiquetar_eliminados'));

    this.valoresIniciales = this.getValores();
    // select2 lanza los eventos con jquery, no podemos usar addEventListener
    this.$select.on('change', () => {
      this.comprobarEliminados();
    });
  }

  comprobarEliminados() {
    if (isEmpty(this.valoresIniciales)) {
      return;
    }
    const valoresActuales = this.getValores();

    const eliminados = [];
    this.valoresIniciales.forEach((tag) => {
      if (!valoresActuales.includes(tag)) {
        eliminados.push(tag);
      }
    });
    this.tagsEliminados = eliminados;
    this.$inputEliminados.val(this.tagsEliminados.join(','));
  }

  getValores() {
    return map(this.$select.find('option:selected'), (el) => $(el).val());
  }
}
